<form *slUiKitIfNotReadyToDisplay [formGroup]="form"  >
  <section>
 
    @if(shouldShowEnableAutomatedTransfer) {
      <div class="row mb-3">
        <div class="col-md-12 form-group">
          <label class="s_label-tooltip">Enable Automated Transfer</label>
          <label class="s_switch">
              <input id="enabled-automated-transfers-enabled" type="checkbox" formControlName="enableAutomatedTransfer">
              <div class="s_slider round">
                  <span class="on">YES</span><span class="off">NO</span>
              </div>
          </label>
        </div>
      </div>
    }

    <div class="row">
        <div class="form-group col">
            <label>Account <span class="font-weight-bolder">From</span></label>
            <div class="input-group">
              @if(isFromAccountPicklist()) {
                <select class="form-control" formControlName="fromAccountNumber">
                @for (s of accounts; track s.number) {
                  <option [value]="s.number">
                    {{ s.number }}
                  </option>
                }
                </select>
              } @else {
                 <input formControlName="fromAccountNumber" type="text" class="form-control">
              }
            </div> 
        </div> 
    </div>
    <div class="row">
        <div class="form-group col">
            <label>Account <span class="font-weight-bolder">To</span></label>
            <div class="input-group">
              @if(isToAccountPicklist()) {
                <select class="form-control" formControlName="toAccountNumber">
               
                  @for ( s of accounts; track s.number) {
                    <option   [value]="s.number">
                      {{ s.number }}
                    </option>
                  }
                
                </select>
              } @else {
                <input formControlName="toAccountNumber" type="text" class="form-control">
              }
            </div> 
        </div> 
    </div>

    @if(shouldShowMaxSeizableAmountLabel) {
      <div class ="row mt-3">
        <div class="form-group col-md-12">
          <label>Maximum seizable amount: {{this.garnishmentFinancialsInfo?.maxSeizableAmount | currency }}</label>
        </div>
      </div>
    }
    @if(shouldShowMaxReleasableAmountLabel) {
      <div class ="row mt-3">
        <div class="form-group col-md-12">
          <label>Maximum releasable amount: {{maxReleasableAmount | currency }}</label>
        </div>
      </div>
    }
    <div class="row">
        <div class="form-group col">
            <label>Amount@if(shouldShowMinimalThresholdAmount){<span class="s_minimal-threshold-amount">{{requiredMinimumText}}</span>}</label>
            <div class="input-group">
                <input currencyMask formControlName="amount" type="text" class="form-control">
            </div> 
        </div> 
    </div>

  </section>
</form>